export const statusOption = [
  { id: -1, name: 'Show All' },
  { id: 1, name: 'Active' },
  { id: 0, name: 'InActive' },
]
export const cellStyles = {
  whiteSpace: 'nowrap',
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '500',
  alignItems: 'center',
  padding: '7px 12px',
  minHeight: '36px',
  color: '#444',
  // justifyContent: 'center',
  //  textAlign: 'center'
}
 export const saveInitialValueData = {
            intCompanyID: 0,
            IsParty: 0,
            IsDescriptionDisable: 0,
            IsGoodsValueDisable: 0,
            // intIsFreight: 0,
            IsCartageDisable: 0,
            IsDocumentDisable: 0,
            IsInsuranceDisable: 0,
            RemoveValuation: 0,
            IsInsuranceCompulsory: 0,
            IsServiceTax: 0,
            IsWeightDisable: 0,
            IsBillNoDisable: 0,
            IsManual: 0,
            IsOnAccount: 0,
            IsHamaliDisable: 0,
            IsDelCartage: 0,
            IsCartageRemarkDisable: 0,
            IsPartyForAllPayType: 0,
            IsPartyForSenderReceiver: 0,
            GstType: 0,
            ChallanType: 0,
            ChallanCopies: 0,
            ReceiveType: 0,
            IsPartyDetailsMandatory: 0,
            CargoIsAutoReceiveDispatch: 0,
            CargoAutoReceiveDispatchDays: 0,
            CargoIsAutoReceiveBranchTransfer: 0,
            CargoAutoReceiveBranchTransferDays: 0,
            IsDelBranchChange: 0,
            IsDelivery: 0,
            HasFTLBooking: 0,
            HasEwayBillNoDisable: 0,
            HasDetailsOnDelivery: 0,
            HasNoBeforeName: 0,
            StickerCopiesType: 0,
            HasWeightRoundUp: 0,
            HasFoCApproval: 0,
            ShowAllLrOption: 0,
            HasGSTOnDelivery: 0,
            IsSTACompany : 0,
            HasCrossingCity: 0,
            InsuranceProviderID: 0,
            StickerType: 0,
            HasOwnBookingRestricted: 0,
            DefaultBookingPmtType: 0,
            HasAutoCrossing: 0,
            HasAutoReceive: 0,
            IsMOPDisable: 0,
            IsFocOtp: 0,
            IsSMSForNearestBranch: 0,
            IsQRForBranchRecharge: 0,
            QRProviderID: 0,
            IsOnlyDispatchCities: 0,
            IsShowAdditional: 0,
            IsOperatorHamaliDisable: 0,
            IsAllowJackUpOnQR: 0,
            IsGSTIN_Directory: 0,
            IsPickUpAndDropOffChg: 0,
            IsDropoffFeeDisable: 0,
            PickUpFeeDisable: 0,
            IsFreightCartageOptHamaliGST: 0,
            HideHiredVehicle: 0,
            IsBusScheduleDispatchUpdate: 0,
            IsGoodsValueCompulsory: 0,
            IsLimitOnUnitAndFreight: 0,
            UseToPayAsCOD: 0,
            NoOfUnits: 0,
            NoOfFreight: 0,
            IsCashbookEnabled: 0,
            IsCashbookLimitEnabled: 0,
            IsCashbookInOwnFranchEnabled: 0,
            IsEnableOutForDelivery: 0,
            IsMultipleConsignment: 0,
            IsBookingBranchUserForOfflineBkng: 0,
            IsLoggedInUserForOfflineBooking: 0,
            IsCreditTopay: 0,
            MinCargoFrightAmt: 0,
            IsMobNoInDispatchRpt: 0,
            IsHamInBookingRpt: 0,
            IsDescInDispatchRpt: 0,
            IsCommentInDispatchRpt: 0,
            IsEwayBillValidate: 0,
            IsConvCharge: 0,
            MinWeightPerLR: 0,
            IsForceFTL: 0,
            IsMinimumGoodsValue: 0,
            IsQRRechargeAmount: 0,
            MinFTLUnits: 0,
            MinFTLWeight: 0,
            MinFTLFreight: 0,
            MinGoodsValue: 0,
            MinQrAmount: 0,
            WebCargoEnabledMode: 0,
            BypassGSTINValidation: 0,
            AllowMultiCityDispatch: 0,
            RemoveWebDispChallanInExeFormat: 0,
            IsRechargeApprovalOTP: 0,
            OnAccountCreditPortrait: 0,
            IsNonMovementPortrait: 0,
            IsEwaybillReportPortrait: 0,
            IsPartyBookingPortrait: 0,
            IsPartyBusinessPortrait: 0,
            IsBranchCrlTxnsPortrait: 0,
            IsPartyCrlTxnsPortrait: 0,
            BookingReportPortrait: 0,
            BranchTransferPortrait: 0,
            BranchTransferReceivePortrait: 0,
            DispatchReportPortrait: 0,
            ReceiveReportPortrait: 0,
            DeliveryReportPortrait: 0,
            RefundReportPortrait: 0,
            IsMobNoInDispatchReport: 0,
            IsDescriptionInDispatchRep: 0,
            IsHamaliInBookingReport: 0,
            IsCommentInDispatchRep: 0,
            UseFormattedLRinReports: 0,
            AllowNonMovementReport: 0,
            IsNonMovProcessed: 0,
            IsUploadRchTxnReceipt: 0,
            EnableRechargeRequest: 0,
            IsBookingDeliveryWithQR: 0,
            FTLMinActWeight: 0,
            HasPTLBooking: 0,
            IsSenderNoCompulsory: 0,
            IsSenderNoDisable: 0,
            IsSenderNoRemove: 0,
            IsSenderCityAndStateDisable: 0,
            IsSenderCityAndStateRemove: 0,
            IsSenderCityAndStateCompulsory: 0,
            RemoveSenderGSTIN: 0,
            IsSenderGSTINDisable: 0,
            IsSenderGSTINCompulsory: 0,
            RemoveSenderID: 0,
            IsSenderIDProofDisable: 0,
            IsSenderIDProofCompulsory: 0,
            IsRemoveSenderOtherInfo: 0,
            IsSenderOtherInfoDisable: 0,
            IsSenderOtherInfoCompulsory: 0,
            IsReceiverOtherInfoDisable:0,
            IsRemoveReceiverOtherInfo:0,
            IsReceiverOtherInfoCompulsory:0,
            RemoveHomePickup: 0,
            IsHomePickUpDisable: 0,
            IsHomePickUpCompulsory: 0,
            RemoveBillInfo: 0,
            IsBillNoCompulsory: 0,
            RemoveEwayBillNo: 0,
            IsEwayBillCompulsory: 0,
            IsRecvNoCompulsory: 0,
            IsReceiverNoDisable: 0,
            IsReceiverNoRemove: 0,
            IsRecCityAndStateDisable: 0,
            IsRecCityAndStateRemove: 0,
            IsRecCityAndStateCompulsory: 0,
            RemoveReceiverGSTIN: 0,
            IsRecGSTINDisable: 0,
            IsRecGSTINCompulsory: 0,
            RemoveHomeDelivery: 0,
            IsHomeDeliveryDisable: 0,
            IsHomeDeliveryCompulsory: 0,
            RemoveCartageremark: 0,
            IsCartageRemarkCompulsory: 0,
            RemoveComment: 0,
            IsCommentRemove: 0,
            IsCommentCompulsory: 0,
            RemovePaymentMode: 0,
            IsPaymentModeDisable: 0,
            IsPaymentModeCompulsory: 0,
            RemoveAccountnumber: 0,
            IsAccountNoDisable: 0,
            IsAccountNoCompulsory: 0,
            RemoveReferenceID: 0,
            IsReferenceIDDisable: 0,
            IsReferenceIDCompulsory: 0,
            RemoveDescription: 0,
            IsDescriptionCompulsory: 0,
            RemovePackMethod: 0,
            IsPackMethodCompulsory: 0,
            RemoveGoodsvalue: 0,
            RemoveActualWeight: 0,
            IsActualWeightCompulsory: 0,
            RemoveCFTWeight: 0,
            IsCFTWeightCompulsory: 0,
            IsCFTWeightDisable: 0,
            RemoveChargeWeight: 0,
            IsChargedWeightDisable: 0,
            IsChargedWeightCompulsory: 0,
            RemoveBookingPageRate: 0,
            IsBookingPageRateDisable: 0,
            IsBookingPageRateCompulsory: 0,
            IsFreightRemove: 0,
            IsFreightRemoveCompulsory: 0,
            RemovePickupcartage: 0,
            IsPickUpCartageCompulsory: 0,
            RemoveMisccartage: 0,
            IsMiscChgRemove: 0,
            IsMiscCompulsory: 0,
            RemoveBookingDropcartage: 0,
            IsDropCartageDisable: 0,
            IsDropCartageCompulsory: 0,
            IsBookingHamaliCompulsory: 0,
            RemoveHamali: 0,
            IsBookingOpHamaliCompulsory: 0,
            RemoveOpHamali: 0,
            RemoveDocfee: 0,
            IsDocumentFeeCompulsory: 0,
            RemovePickupfee: 0,
            RemoveDropofffee: 0,
            IsPickupFeeCompulsory: 0,
            IsDropoffFeeCompulsory: 0,
            IsConvChgCompulsory: 0,
            IsConvChgDisable: 0,
            SetDefaultBookCargo: 0,
            SetDefaultYesOnPrint: 0,
            IsBookingWithEwayBill: 0,
            IsCollChg: 0,
            HasCartageBreakup: 0,
            HasContactNoCompulsory: 0,
            IsDemurrage: 0,
            IsExtraHamali: 0,
            IsSTACode: 0,
            DefaultPaymentType:1,
            IsFreightDisable:0,
            IsFreightRemoveCompulsory:0,
        }
export const columnDefs = [
  { headerName: 'SR	', field: 'srNo', headerSx: { textAlign: 'right', minWidth: "40px" }, showfilter: false },
  { headerName: 'Company ID', field: 'CompanyID', headerSx: { textAlign: 'left', minWidth: "100px" }, showfilter: true },
  { headerName: 'Company Code', field: 'CompanyCode', headerSx: { textAlign: 'left', minWidth: "100px" }, showfilter: true },
  { headerName: 'Company Name', field: 'CompanyName', headerSx: { textAlign: 'left', minWidth: "100px" }, showfilter: true },
  { headerName: 'City', field: 'CityName', headerSx: { textAlign: 'left', minWidth: "80px" }, showfilter: true },
  { headerName: 'State', field: 'StateName', headerSx: { textAlign: 'left', minWidth: "100px" }, showfilter: true },
  { headerName: 'Region', field: 'RegionName', headerSx: { textAlign: 'left', minWidth: "180px" }, showfilter: true },
  { headerName: 'Regional Manager', field: 'B2BManagerEmail', headerSx: { textAlign: 'left', minWidth: "180px" }, showfilter: true },
  { headerName: 'Ops Member', field: 'OPSManagerEmail', headerSx: { textAlign: 'left', minWidth: "180px" }, showfilter: true },
  { headerName: 'Branches', field: 'NoofBranches', headerSx: { textAlign: 'left', minWidth: "100px" }, showfilter: true },
  { headerName: 'Status', field: 'STATUS', headerSx: { textAlign: 'left', minWidth: "130px" }, showfilter: true },
  { headerName: 'Luggage Settings', field: 'LuggageSettings', headerSx: { textAlign: 'left', minWidth: "130px" }, showfilter: false },
]

export const bookingConfigColDefs = [
  { headerName: 'FIELD NAME', fieldName: 'field', headerSx: { textAlign: 'left', minWidth: "25%" }, showfilter: false },
  { headerName: 'REMOVE', fieldName: 'isRemove', headerSx: { textAlign: 'center', minWidth: "25%" }, showfilter: false },
  { headerName: 'DISABLE', fieldName: 'isDisable', headerSx: { textAlign: 'center', minWidth: "25%" }, showfilter: false },
  { headerName: 'MANDATORY', fieldName: 'isMandatory', headerSx: { textAlign: 'center', minWidth: "25%" }, showfilter: false },
]
export const SenderDetails = [
  { field: 'SENDER NUMBER', isRemove: 'IsSenderNoRemove', isDisable: 'IsSenderNoDisable', isMandatory: 'IsSenderNoCompulsory' },
  { field: 'SENDER NAME', isRemove: 0, isDisable: 0, isMandatory: 1, isCompalsary: true },
  { field: 'SENDER CITY & STATE', isRemove: 'IsSenderCityAndStateRemove', isDisable: 'IsSenderCityAndStateDisable', isMandatory: 'IsSenderCityAndStateCompulsory' },
  { field: 'SENDER GSTIN', isRemove: 'RemoveSenderGSTIN', isDisable: 'IsSenderGSTINDisable', isMandatory: 'IsSenderGSTINCompulsory' },
  { field: 'SENDER ID PROOF', isRemove: 'RemoveSenderID', isDisable: 'IsSenderIDProofDisable', isMandatory: 'IsSenderIDProofCompulsory' },
  { field: 'SENDER IMAGE', isRemove: 'RemoveSenderID', isDisable: 'IsSenderIDProofDisable', isMandatory: 'IsSenderIDProofCompulsory' },
  { field: 'SENDER OTHER INFO', isRemove: 'IsRemoveSenderOtherInfo', isDisable: 'IsSenderOtherInfoDisable', isMandatory: 'IsSenderOtherInfoCompulsory' },
  { field: 'HOME PICKUP', isRemove: 'RemoveHomePickup', isDisable: 'IsHomePickUpDisable', isMandatory: 'IsHomePickUpCompulsory' },
]
export const LegalCompliance = [
  { field: 'BILL DETAILS', isRemove: 'RemoveBillInfo', isDisable: 'IsBillNoDisable', isMandatory: 'IsBillNoCompulsory' },
  { field: 'EWAYBILL', isRemove: 'RemoveEwayBillNo', isDisable: 'HasEwayBillNoDisable', isMandatory: 'IsEwayBillCompulsory' },
]
export const ReceiverDetails = [
  { field: 'RECEIVER NUMBER', isRemove: 'IsReceiverNoRemove', isDisable: 'IsReceiverNoDisable', isMandatory: 'IsRecvNoCompulsory' },
  { field: 'RECEIVER NAME', isRemove: 0, isDisable: 0, isMandatory: 1, isCompalsary: true },
  { field: 'RECEIVER CITY & STATE', isRemove: 'IsRecCityAndStateRemove', isDisable: 'IsRecCityAndStateDisable', isMandatory: 'IsRecCityAndStateCompulsory' },
  { field: 'RECEIVER OTHER INFO', isRemove: 'IsRemoveReceiverOtherInfo', isDisable: 'IsReceiverOtherInfoDisable', isMandatory: 'IsReceiverOtherInfoCompulsory' },
  { field: 'RECEIVER GSTIN', isRemove: 'RemoveReceiverGSTIN', isDisable: 'IsRecGSTINDisable', isMandatory: 'IsRecGSTINCompulsory' },
  { field: 'HOME DELIVERY', isRemove: 'RemoveHomeDelivery', isDisable: 'IsHomeDeliveryDisable', isMandatory: 'IsHomeDeliveryCompulsory' },
]
export const BoookingOtherDetails = [
  { field: 'CARTAGE REMARKS', isRemove: 'RemoveCartageremark', isDisable: 'IsCartageRemarkDisable', isMandatory: 'IsCartageRemarkCompulsory' },
  { field: 'COMMENT', isRemove: 'RemoveComment', isDisable: 'IsCommentRemove', isMandatory: 'IsCommentCompulsory' },
  { field: 'METHOD OF PAYMENT', isRemove: 'RemovePaymentMode', isDisable: 'IsPaymentModeDisable', isMandatory: 'IsPaymentModeCompulsory' },
  { field: 'ACCOUNT NO', isRemove: 'RemoveAccountnumber', isDisable: 'IsAccountNoDisable', isMandatory: 'IsAccountNoCompulsory' },
  { field: 'REFERENCE ID', isRemove: 'RemoveReferenceID', isDisable: 'IsReferenceIDDisable', isMandatory: 'IsReferenceIDCompulsory' },
]
export const ConsignmentDetails = [
  { field: 'CONSIGNMENT TYPE', isRemove: 0, isDisable: 0, isMandatory: 1, isCompalsary: true },
  { field: 'DESCRIPTION', isRemove: 'RemoveDescription', isDisable: 'IsDescriptionDisable', isMandatory: 'IsDescriptionCompulsory' },
  { field: 'PACK METHOD', isRemove: 'RemovePackMethod', isDisable: 'IsMOPDisable', isMandatory: 'IsPackMethodCompulsory' },
  { field: 'UNIT', isRemove: 0, isDisable: 0, isMandatory: 1, isCompalsary: true },
  { field: 'GOODS VALUE', isRemove: 'RemoveGoodsvalue', isDisable: 'IsGoodsValueDisable', isMandatory: 'IsGoodsValueCompulsory' },
  { field: 'WEIGHT (ACTUAL)', isRemove: 'RemoveActualWeight', isDisable: 'IsWeightDisable', isMandatory: 'IsActualWeightCompulsory' },
  { field: 'WEIGHT (CFT)', isRemove: 'RemoveCFTWeight', isDisable: 'IsCFTWeightDisable', isMandatory: 'IsCFTWeightCompulsory' },
  { field: 'WEIGHT (CHARGE)', isRemove: 'RemoveChargeWeight', isDisable: 'IsChargedWeightDisable', isMandatory: 'IsChargedWeightCompulsory' },
  { field: 'RATE', isRemove: 'RemoveBookingPageRate', isDisable: 'IsBookingPageRateDisable', isMandatory: 'IsBookingPageRateCompulsory' },
  { field: 'FREIGHT', isRemove: 0, isDisable: 'IsFreightDisable', isMandatory: 'IsFreightRemoveCompulsory',},
]
export const BookingOtherCharges = [
  { field: 'PICKUP CARTAGE', isRemove: 'RemovePickupcartage', isDisable: 'IsCartageDisable', isMandatory: 'IsPickUpCartageCompulsory' },
  { field: 'MISC. CARTAGE', isRemove: 'RemoveMisccartage', isDisable: 'IsMiscChgRemove', isMandatory: 'IsMiscCompulsory' },
  { field: 'DROP CARTAGE', isRemove: 'RemoveBookingDropcartage', isDisable: 'IsDropCartageDisable', isMandatory: 'IsDropCartageCompulsory' },
  { field: 'BOOKING HAMALI', isRemove: 'RemoveHamali', isDisable: 'IsHamaliDisable', isMandatory: 'IsBookingHamaliCompulsory' },
  { field: 'BOOKING OP. HAMALI', isRemove: 'RemoveOpHamali', isDisable: 'IsOperatorHamaliDisable', isMandatory: 'IsBookingOpHamaliCompulsory' },
  { field: 'VALUATION / INSURANCE', isRemove: 'RemoveValuation', isDisable: 'IsInsuranceDisable', isMandatory: 'IsInsuranceCompulsory' },
  { field: 'DOCUMENT FEE', isRemove: 'RemoveDocfee', isDisable: 'IsDocumentDisable', isMandatory: 'IsDocumentFeeCompulsory' },
  { field: 'PICKUP FEE', isRemove: 'RemovePickupfee', isDisable: 'PickUpFeeDisable', isMandatory: 'IsPickupFeeCompulsory' },
  { field: 'DROPOFF FEE', isRemove: 'RemoveDropofffee', isDisable: 'IsDropoffFeeDisable', isMandatory: 'IsPickupFeeCompulsory' },
  { field: 'CONVEYANCE FEE', isRemove: 'IsConvCharge', isDisable: 'IsConvChgDisable', isMandatory: 'IsConvChgCompulsory' },
]
export const GSTTypeConfig = [
  {
    type: "checkboxRow",
    leftLabel: "IS GST",
    leftValue: 'IsServiceTax',
    rightLabel: "IS HANS TYPE GST?",
    rightValue: 'IsFreightCartageOptHamaliGST',
  },
  {
    type: "checkboxRow",
    leftLabel: "IS GST ON DELIVERY",
    leftValue: 'HasGSTOnDelivery',
    rightLabel: "IS GSTIN DIRECTORY?",
    rightValue: 'IsGSTIN_Directory',
    rightStyle: { backgroundColor: "#FF4C4C", color: "white" },
  },
  {
    type: "radioRow",
    leftLabel: "GST BY PAYER (HANS)",
    leftValue: 'GstType',
    rightLabel: "GST BY SNDR/RCVR (STA)",
    rightValue: 'GstType',
  },
]

export const bookingEventConfigData = [
  {
    section: "BOOKING GENERAL CONFIG",
    rows: [
      {
        leftLabel: "IS OWN BOOKING RESTRICT?",
        leftType: "checkbox",
        leftValue: 'HasOwnBookingRestricted',
        rightLabel: "DEFAULT PAYMENT TYPE",
        rightType: "DropDown",
        rightValue: true,
        rightStyle: '',
      },
      {
        leftLabel: "IS STA TYPE PAGE IN EXE?",
        leftType: "checkbox",
        leftValue: 'IsSTACompany',
        leftStyle: '',
        rightLabel: "IS ON-ACCOUNT BOOKINGS?",
        rightType: "checkbox",
        rightValue: 'IsOnAccount',
      },
      {
        leftLabel: "IS NO BEFORE NAME",
        leftType: "checkbox",
        leftValue: 'HasNoBeforeName',
        leftStyle: '',
        rightLabel: "IS MANUAL BOOKINGS?",
        rightType: "checkbox",
        rightValue: 'IsManual',
      },
      {
        leftLabel: "IS MULTIPLE CONSIGNMENT?",
        leftType: "checkbox",
        leftValue: 'IsMultipleConsignment',
        leftStyle: '',
        rightLabel: "IS FOC BOOKING APPROVAL?",
        rightType: "checkbox",
        rightValue: 'HasFoCApproval',
      },
      {
        leftLabel: "BYPASS GST VALIDATION",
        leftType: "checkbox",
        leftValue: 'BypassGSTINValidation',
        leftStyle: '',
        rightLabel: "IS FOC BOOKING OTP?",
        rightType: "checkbox",
        rightValue: 'IsFocOtp',
      },
      {
        leftLabel: "IS BOOK WITH EWAYBILL",
        leftType: "checkbox",
        leftValue: 'IsBookingWithEwayBill',
        leftStyle: '',
        rightLabel: "IS FTL BOOKING?",
        rightType: "checkbox",
        rightValue: 'HasFTLBooking',
      },
      {
        leftLabel: "SET DEFAULT BOOK CARGO",
        leftType: "checkbox",
        leftValue: 'SetDefaultBookCargo',
        leftStyle: '',
        rightLabel: "SET DEFAULT YES ON PRINT",
        rightType: "checkbox",
        rightValue: 'SetDefaultYesOnPrint',
      },
      {
        leftLabel: "HAS DELIVERY TYPE?",
        leftType: "checkbox",
        leftValue: 'IsDelivery',
        leftStyle: {},
        rightLabel: "HAS WEIGHT ROUND UP?",
        rightType: "checkbox",
        rightValue: 'HasWeightRoundUp',
      },
    ],
  },
  {
    section: "PARTY BOOKING CONFIG",
    rows: [
      {
        leftLabel: "IS PARTY BOOKING?",
        leftType: "checkbox",
        leftValue: 'IsParty',
        rightLabel: "",
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "ALL BOOKING TYPE",
        leftType: "radio",
        leftValue: 'IsPartyForAllPayType',
        leftRadioValue:1,
        rightRadioValue:0,
        rightLabel: "ON ACCOUNT TYPE",
        rightType: "radio",
        rightValue: 'IsPartyForAllPayType',
      },
    ],
  },
  {
    section: "PARTY SELECTION FOR:",
    rows: [
      {
        leftLabel: "SENDER AND RECEIVER (BOTH)",
        leftType: "radio",
        leftValue: 'IsPartyForSenderReceiver',
        leftRadioValue:1,
        rightRadioValue:0,
        rightLabel: "SENDER OR RECEIVER (ANY 1)",
        rightType: "radio",
        rightValue: 'IsPartyForSenderReceiver',
      },
    ],
  },
  {
    section: "PARTY DETAILS:",
    rows: [
      {
        leftLabel: "MANDATORY",
        leftType: "radio",
        leftValue: 'IsPartyDetailsMandatory',
        leftRadioValue:1,
        rightRadioValue:0,
        rightLabel: "NON MANDATORY",
        rightType: "radio",
        rightValue: 'IsPartyDetailsMandatory',
      },
    ],
  },
  {
    section: "QR TRANSACTIONS FUNCTIONALITY",
    rows: [
      {
        leftLabel: "QR PAYMENT FOR RECHARGE",
        leftType: "checkbox",
        leftValue: 'IsQRForBranchRecharge',
        rightLabel: "IS ALLOW JACKUP?",
        rightType: "checkbox",
        rightValue: 'IsAllowJackUpOnQR',
      },
      {
        leftLabel: "IDFC BANK",
        leftType: "radio",
        leftValue: 'QRProviderID',
        leftRadioValue:1,
        rightRadioValue:2,
        rightLabel: "YES BANK",
        rightType: "radio",
        rightValue: 'QRProviderID',
      },
      {
        leftLabel: "BOOKING AND DELIVERY WITH QR",
        leftType: "checkbox",
        leftValue: 'IsBookingDeliveryWithQR',
        rightLabel: "REMOVE QR TRANSFER FEE FROM CUSTOMER AMOUNT",
        rightType: "checkbox",
        rightValue: 'RemoveQRTransFeeFromCustAmt',
      },
      {
        leftLabel: "ENABLE RECHARGE REQUEST",
        leftType: "checkbox",
        leftValue: 'EnableRechargeRequest',
        rightLabel: "UPLOAD RECH. TXNS. RECEIPT",
        rightType: "checkbox",
        rightValue: 'IsUploadRchTxnReceipt',
      },
    ],
  },
];
export const bookingEventConfigDataForOfflineBooking = [
  {
    section: "SELECT USER FOR OFFLINE BOOKING",
    rows: [
      {
        leftLabel: "IS BOOKING BRANCH USER",
        leftType: "radio",
        leftValue: 'IsBookingBranchUserForOfflineBkng',
        leftRadioValue:1,
        rightRadioValue:2,
        rightLabel: "IS LOGGED IN USER",
        rightType: "radio",
        rightValue: 'IsLoggedInUserForOfflineBooking',
        rightStyle: '',
      },
    ],
  },
  {
    section: "STICKER PRINT CONFIG",
    rows: [
      {
        leftLabel: "STICKER USE TYPE",
        leftType: "",
        leftValue: 'true',
        rightLabel: "",
        rightType: "",
        rightValue: true,
        rightStyle: '',
      },
      {
        leftLabel: "FOR NORMAL USE",
        leftType: "radio",
        leftValue: 'StickerType',
        leftRadioValue:1,
        rightRadioValue:2,
        rightLabel: "FOR MAVEN APP",
        rightType: "radio",
        rightValue: 'StickerType',
        rightStyle: '',
      },
      {
        leftLabel: "STICKER COPIES",
        leftType: "",
        leftValue: 'true',
        rightLabel: "",
        rightType: "",
        rightValue: true,
        rightStyle: '',
      },
      {
        leftLabel: "SINGLE PER LR",
        leftType: "radio",
        leftValue: 'StickerCopiesType',
        leftRadioValue:1,
        rightRadioValue:2,
        rightLabel: "SAME AS TOTAL UNITS",
        rightType: "radio",
        rightValue: 'StickerCopiesType',
        rightStyle: '',
      },
      // {
      //   leftLabel: "",
      //   leftType: "",
      //   leftValue: true,
      //   rightLabel: "",
      //   rightType: "",
      //   rightValue: true,
      //   rightStyle: '',
      // },
      // {
      //   leftLabel: "",
      //   leftType: "",
      //   leftValue: true,
      //   rightLabel: "",
      //   rightType: "",
      //   rightValue: true,
      //   rightStyle: '',
      // },
    ],
  },
  {
    section: "FORCE TRANSACTIONS",
    rows: [
      {
        leftLabel: "FORCE PTL?",
        leftType: "checkbox",
        leftValue: 'IsForcePTL',
        rightLabel: "",
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "MIN UNITS",
        leftType: "text",
        leftValue: 'MinFTLUnits',
        leftStyle: { },
        rightLabel: "MIN WEIGHT CHARGED",
        rightType: "text",
        rightValue: 'MinFTLWeight',
        rightStyle: { },
      },
      {
        leftLabel: "MIN FREIGHT AMOUNT:",
        leftType: "text",
        leftValue: 'MinFTLFreight',
        leftStyle: { },
        rightLabel: "",
        rightType: "",
        rightValue: '',
        rightStyle: '',
      },
      {
        leftLabel: "FORCE FTL?",
        leftType: "checkbox",
        leftValue: 'IsForceFTL',
        rightLabel: "",
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "MIN UNITS",
        leftType: "text",
        leftValue: 'isDisable',
        leftStyle: { },
        middleStyle: { },
        rightLabel: "MIN WEIGHT CHARGED",
        rightType: "text",
        rightValue: 'FTLMinActWeight',
        rightStyle: { },
      },
      {
        leftLabel: "MIN FREIGHT AMOUNT:",
        leftType: "text",
        leftValue: 'isDisable',
        leftStyle: { },
        rightLabel: "",
        rightType: "",
        rightValue: '',
        rightStyle: '',
      },
    ],
  },
  {
    section: "MINIMUM BOOKING LIMITS",
    rows: [
      {
        leftLabel: "MINIMUM GOODS VALUE?",
        leftType: "text",
        leftValue: 'MinGoodsValue',
        leftStyle: { },
        rightLabel: "MIN QR RECHARGE AMT?",
        rightType: "text",
        rightValue: 'MinQrAmount',
        rightStyle: { },
      },
      {
        leftLabel: "MINIMUM BOOKING FREIGHT AMT?",
        leftType: "text",
        leftValue: 'MinCargoFrightAmt',
        leftStyle: { },
        rightLabel: "MINIMUM WEIGHT PER LR?",
        rightType: "text",
        rightValue: 'MinWeightPerLR',
        rightStyle: { },
      },
    ],
  },
  {
    section: "MAXIMUM BOOKING LIMITS",
    rows: [
      {
        leftLabel: "MAXIMUM BOOKING LIMIT?",
        leftType: "checkbox",
        leftValue: 'IsLimitOnUnitAndFreight',
        leftStyle: '',
        rightLabel: "MAX UNITS :",
        rightType: "text",
        rightValue: 'NoOfUnits',
        rightStyle: { },
      },
      {
        leftLabel: "MAX FREIGHT :",
        leftType: "text",
        leftValue: 'NoOfFreight',
        leftStyle: { },
        rightLabel: "",
        rightType: "",
        rightValue: '',
        rightStyle: '',
      },
    ],
  },
  {
    section: "CHANGE PAYMENT TYPE FROM TOPAY TO COD",
    rows: [
      {
        leftLabel: "USE TOPAY AS COD",
        leftType: "checkbox",
        leftValue: 'UseToPayAsCOD',
        leftStyle: '',
        rightLabel: "",
        rightType: "",
        rightValue: '',
        rightStyle: { },
      },
    ],
  },
];
export const otherEventConfigData = [
  {
    section: "DISPATCH EVENT CONFIG",
    rows: [
      {
        leftLabel: "HAS CROSSING CITY?",
        leftType: "checkbox",
        leftValue: 'HasCrossingCity',
        rightLabel: "HIDE HIRED VEHICLE?",
        rightType: "checkbox",
        rightValue: 'HideHiredVehicle',
        rightStyle: '',
      },
      {
        leftLabel: "DISPATCH AFTER BUS SCHEDULE?",
        leftType: "checkbox",
        leftValue: 'IsBusScheduleDispatchUpdate',
        rightLabel: "IS DEL. BRANCH CHANGE?",
        rightType: "checkbox",
        rightValue: 'IsDelBranchChange',
        rightStyle: '',
      },
      {
        leftLabel: "ALLOW MULTICITY DISPATCH?",
        leftType: "checkbox",
        leftValue: 'AllowMultiCityDispatch',
        rightLabel: "IS ONLY DISPATCH CITIES?",
        rightType: "checkbox",
        rightValue: 'IsOnlyDispatchCities',
        rightStyle: '',
      },
      {
        leftLabel: "CHALLAN TYPE",
        leftType: "",
        leftValue: '',
        rightLabel: "PAYMENT TYPE WISE",
        rightType: "radio",
        rightValue: 'ChallanType',
        rightRadioValue:1,
        rightStyle: '',
      },
      {
        leftLabel: "ALL IN ONE (NON-WEB)",
        leftType: "radio",
        leftValue: 'ChallanType',
        leftRadioValue:2,
        rightLabel: "ALL IN ONE (WEB)",
        rightType: "radio",
        rightValue: 'ChallanType',
        rightRadioValue:3,
        rightStyle: '',
      },
      {
        leftLabel: "CHALLAN COPIES",
        leftType: "text",
        leftValue: 'ChallanCopies',
        leftStyle: { },
        rightLabel: "IS CHALLAN IN EXE FORMAT?",
        rightType: "checkbox",
        rightValue: 'RemoveWebDispChallanInExeFormat',
        rightStyle: '',
      },
    ],
  },
  {
    section: "DELIVERY EVENT CONFIG",
    rows: [
      {
        leftLabel: "IS DELIVERY CARTAGE?",
        leftType: "checkbox",
        leftValue: 'IsDelCartage',
        rightLabel: "IS DETAILS ON DELIVERY?",
        rightType: "checkbox",
        rightValue: 'HasDetailsOnDelivery',
        rightStyle: '',
      },
      {
        leftLabel: "IS CREDIT IN TOPAY DELIVERY?",
        leftType: "checkbox",
        leftValue: 'IsCreditTopay',
        rightLabel: "ENABLE OUT-DELIVERY?",
        rightType: "checkbox",
        rightValue: 'IsEnableOutForDelivery',
        rightStyle: '',
      },
    ],
  },
  {
    section: "OTHER CONFIG",
    rows: [
      {
        leftLabel: "SHOW ADDITIONAL (MODIFY)",
        leftType: "checkbox",
        leftValue: 'IsShowAdditional',
        rightLabel: "HAS AUTO CROSSING?",
        rightType: "checkbox",
        rightValue: 'HasAutoCrossing',
        rightStyle: '',
      },
      {
        leftLabel: "SHOW ALL LR OPTION  (LR SEARCH)",
        leftType: "checkbox",
        leftValue: 'ShowAllLrOption',
        rightLabel: "HAS AUTO RECEIVE?",
        rightType: "checkbox",
        rightValue: 'HasAutoReceive',
        rightStyle: '',
      },
      {
        leftLabel: "IS SMS TO NEAREST BRANCH",
        leftType: "checkbox",
        leftValue: 'IsSMSForNearestBranch',
        rightLabel: "IS RECH APPROVAL OTP?",
        rightType: "checkbox",
        rightValue: 'IsRechargeApprovalOTP',
        rightStyle: '',
      },
      {
        leftLabel: "MPESA CONFIGURATION",
        leftType: "button",
        leftValue: 'mpesaConfig',
        rightLabel: "APPROVAL OTP PHONE NO",
        rightType: "text",
        rightValue: 'BranchRechargeAcceptOtpNo',
        rightStyle: {},
      },
    ],
  },
];
export const otherEventConfigRightData = [
  {
    section: "RECEIVE EVENT CONFIG",
    rows: [
      {
        leftLabel: "BRANCH TRANSFER AUTO REC.",
        leftType: "checkbox",
        leftValue: 'CargoIsAutoReceiveBranchTransfer',
        rightLabel: "DAYS",
        rightStyle: { },
        rightType: "text",
        rightValue: 'CargoAutoReceiveBranchTransferDays',
      },
      {
        leftLabel: "DIPACTH AUTO RECEIVE.",
        leftType: "checkbox",
        leftValue: 'CargoIsAutoReceiveDispatch',
        rightLabel: "DAYS",
        rightStyle: { },
        rightType: "text",
        rightValue: 'CargoAutoReceiveDispatchDays',
      },
      {
        leftLabel: "RECEIVE BY VEHICLE NO",
        leftType: "radio",
        leftValue: 'ReceiveType',
        leftRadioValue: 1,
        rightLabel: "RECEIVE BY CHALLAN NO",
        rightType: "radio",
        rightValue: 'ReceiveType',
        rightStyle: '',
        rightRadioValue: 2,
      },
    ],
  },
  {
    section: "CASHBOOK CONFIG",
    rows: [
      {
        leftLabel: "ENABLE CASHBOOK",
        leftType: "checkbox",
        leftValue: 'IsCashbookEnabled',
        rightLabel: "ENABLE CASHBOOK LIMIT",
        rightType: "checkbox",
        rightValue: 'IsCashbookLimitEnabled',
        rightStyle: '',
      },
      {
        leftLabel: "ENABLE CASHBOOK FOR OWN FRANCHISEE COMPANY",
        leftType: "checkbox",
        leftValue: 'IsCashbookInOwnFranchEnabled',
        rightLabel: "",
        rightType: "",
        rightValue: '',
        rightStyle: '',
      },
    ],
  },
  {
    section: "ENABLE CARGO WEB",
    rows: [
      {
        leftLabel: "Open Cargo Web from Exe",
        leftType: "checkbox",
        leftValue: 'IsOpenCargoWeb',
        rightLabel: "CARGO WEB MAC AUTHENTICATION",
        rightType: "DropDown",
        rightValue: 'WebCargoEnabledMode',
        rightStyle: '',
      },
    ],
  },
];
export const cargoReportReveiwConfigData = [
  {
    section: "CARGO REPORTS PREVIEW CONFIG",
    rows: [
      {
        leftLabel: "ONACCOUNT CREDIT PORTRAIT",
        leftType: "checkbox",
        leftValue: 'OnAccountCreditPortrait',
        rightLabel: "BOOKING REPORT PORTRAIT",
        rightStyle: '',
        rightType: "checkbox",
        rightValue: 'BookingReportPortrait',
      },
      {
        leftLabel: "NON-MOVEMENT PORTRAIT",
        leftType: "checkbox",
        leftValue: 'IsNonMovementPortrait',
        rightLabel: "BR. TRANSFER PORTRAIT",
        rightStyle: '',
        rightType: "checkbox",
        rightValue: 'BranchTransferPortrait',
      },
      {
        leftLabel: "EWAYBILL REPORT PORTRAIT",
        leftType: "checkbox",
        leftValue: 'IsEwaybillReportPortrait',
        rightLabel: "BR. TRA. RECEIVE PORTRAIT",
        rightStyle: '',
        rightType: "checkbox",
        rightValue: 'BranchTransferReceivePortrait',
      },
      {
        leftLabel: "PARTY BOOKING PORTRAIT",
        leftType: "checkbox",
        leftValue: 'IsPartyBookingPortrait',
        rightLabel: "DISPATCH REPORT PORTRAIT",
        rightStyle: '',
        rightType: "checkbox",
        rightValue: 'DispatchReportPortrait',
      },
      {
        leftLabel: "PARTY BUSINESS PORTRAIT",
        leftType: "checkbox",
        leftValue: 'IsPartyBusinessPortrait',
        rightLabel: "RECEIVE REPORT PORTRAIT",
        rightStyle: '',
        rightType: "checkbox",
        rightValue: 'ReceiveReportPortrait',
      },
      {
        leftLabel: "BRANCH CRLTXNS PORTRAIT",
        leftType: "checkbox",
        leftValue: 'IsBranchCrlTxnsPortrait',
        rightLabel: "DELIVERY REPORT PORTRAIT",
        rightStyle: '',
        rightType: "checkbox",
        rightValue: 'DeliveryReportPortrait',
      },
      {
        leftLabel: "PARTY CRLTXNS PORTRAIT",
        leftType: "checkbox",
        leftValue: 'IsPartyCrlTxnsPortrait',
        rightLabel: "REFUND REPORT PORTRAIT",
        rightStyle: '',
        rightType: "checkbox",
        rightValue: 'RefundReportPortrait',
      },
    ],
  },
];
export const cargoReportOtherConfigData = [
  {
    section: "CARGO REPORTS OTHER CONFIG",
    rows: [
      {
        leftLabel: "MOBILE NO IN DISPATCH REPORT?",
        leftType: "checkbox",
        leftValue: 'IsMobNoInDispatchReport',
        rightLabel: "",
        rightStyle: '',
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "DISCRIPTION IN DISPATCH REPORT?",
        leftType: "checkbox",
        leftValue: 'IsDescriptionInDispatchRep',
        rightLabel: "",
        rightStyle: '',
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "HAMALI IN BOOKING REPORT?",
        leftType: "checkbox",
        leftValue: 'IsHamaliInBookingReport',
        rightLabel: "",
        rightStyle: '',
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "COMMENT IN DISP. REPORT?",
        leftType: "checkbox",
        leftValue: 'IsCommentInDispatchRep',
        rightLabel: "",
        rightStyle: '',
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "USE FORMATTED LRS IN REPORTS",
        leftType: "checkbox",
        leftValue: 'UseFormattedLRinReports',
        rightLabel: "",
        rightStyle: '',
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "ALLOW NON MOVEMENT REPORT?",
        leftType: "checkbox",
        leftValue: 'AllowNonMovementReport',
        rightLabel: "",
        rightStyle: '',
        rightType: "",
        rightValue: '',
      },
      {
        leftLabel: "IS NON MOVEMENT PROCESSED?",
        leftType: "checkbox",
        leftValue: 'IsNonMovProcessed',
        rightLabel: "",
        rightStyle: '',
        rightType: "",
        rightValue: '',
      },
    ],
  },
];

export const macAuthentication=[
  {id:0,name:'MAC Check Required at User Level'},
  {id:1,name:'MAC Check Not Required in the Company'},
  {id:2,name:'MAC Check Required at Branch Level'}
]
export const defPaymentType=[
  {id:1,name:'PAID'},
  {id:2,name:'TO-PAY'},
  {id:3,name:'FOC'},
  {id:4,name:'COD'},
  {id:5,name:'On-Account'},
  {id:6,name:'PAID(Manual)'},
  {id:7,name:'TO-PAY(Manual)'},
  {id:8,name:'Self'},
]